import Store from '../SessionStorage'
import { sessionStorageAction } from '../utils'


export const postTrajet = (trajet, duree, productId, entityId, personId) => {
  return fetch(
    `${window.location.origin}/particuliers/auto/assurance-auto-usage/espace-client/declarer-mes-trajets/api/on-demand/task/add`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${Store.get(
          sessionStorageAction.dashboard.accessToken
        )}`
      },
      body: JSON.stringify({
        serviceType: "declarationTrajet",
        entity: "gestion",
        activityType: "declarationTrajet",
        productId,
        entityId,
        personId,
        origin: "EC",
        description:
          `Date du trajet : ${new Date(
            trajet.dateTrajet
          ).toLocaleDateString("fr-FR")}\n` +
          `Horaire du trajet : ${new Date(trajet.horaireTrajet)
            .toLocaleTimeString("fr-FR", {
              hour: "2-digit",
              minute: "2-digit"
            })
            .replace(":", "H")}\n` +
          `Durée du trajet : ${duree} min\n` +
          `Distance du trajet : ${trajet.distance} km\n`
      })
    }
  );
}
